// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"d1264e80","462":"fa1ae6e9","693":"67cff365","983":"f4dfa382"}[chunkId] + ".chunk.js";
};